// Module
var code = `<div class="alert" ng-if="\$ctrl.isAppOutdated">
    Update required: New Nextbank version is released. Please click the update button to update your application.
    <button type="button" class="btn btn-success" ng-click="\$ctrl.updateApp()">Update</button>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/app-version-update/app-version-update.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;